export const trainerLeavesColumns = [
    {
        headerName: "EmployeeName",
        field: "employeeName",
        width: 160,
    },
    {
        headerName: "EmployeeNumber",
        field: "employeeNo",
        width: 160,
    },
    {
        headerName: "EmployeeEmail",
        field: "employeeEmail",
        width: 160
    },
    {
        headerName: "Approver1Name",
        field: "approver1Name",
        width: 160,
    },
    {
        headerName: "Approver1Number",
        field: "approver1No",
        width: 160,
    },
    {
        headerName: "Approver1Email",
        field: "approver1Email",
        width: 160
    },
    {
        headerName: "Approver2Name",
        field: "approver2Name",
        width: 160,
    },
    {
        headerName: "Approver2Number",
        field: "approver2No",
        width: 160,
    },
    {
        headerName: "Approver2Email",
        field: "approver2Email",
        width: 160
    },
    {
        headerName: "Reason",
        field: "reason",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "status",
        headerName: "Status",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];